import { fetcher } from "@/lib/fetcher";

type RequestConfig = RequestInit & {
  body?: BodyInit | null;
};

async function request<T>(url: string, init?: RequestConfig) {
  const data = await fetcher<T>(url, init);
  return { data };
}

export const apiClient = {
  get<T>(url: string) {
    return request<T>(url);
  },
  post<T>(url: string, body?: unknown) {
    return request<T>(url, {
      method: "POST",
      body: body !== undefined ? JSON.stringify(body) : undefined,
    });
  },
  put<T>(url: string, body?: unknown) {
    return request<T>(url, {
      method: "PUT",
      body: body !== undefined ? JSON.stringify(body) : undefined,
    });
  },
  delete<T>(url: string) {
    return request<T>(url, {
      method: "DELETE",
    });
  },
};
